import React, { useContext } from "react";
import { AppContainer } from "@riag-libs/etax-pattern-library";
import AuthService from "../services/AuthService";
import { owTheme } from "@riag-libs/etax-pattern-library/lib/css/owTheme/owTheme";
import { Footer } from "../components/Footer/Footer";
import { nwTheme } from "@riag-libs/etax-pattern-library/lib/css/nwTheme/nwTheme";
import { KantonContext } from "../contexts";
import MainAcceptShare from "../components/Sharing/MainAcceptShare";
import HeaderDefault from "../components/HeaderDefault/HeaderDefault";

function AcceptSharePage() {
  sessionStorage.clear();
  const kantonInfo = useContext(KantonContext);
  return (
    <AppContainer
      header={
        <HeaderDefault
          userName={AuthService.getUsername()}
          mainText={`SMS Code eingeben, um das Teilen zu bestätigen`}
          displayButtons={false}
          breadcrumbs={[
            { text: "Teilen bestätigen", key: "f1", isCurrentItem: true },
          ]}
          backButtonPath={`/`}
          backButtonClear={true}
        />
      }
      main={<MainAcceptShare />}
      footer={<Footer />}
      appTheme={kantonInfo.kanton === "ow" ? owTheme : nwTheme}
    ></AppContainer>
  );
}

export default AcceptSharePage;
